import { useEffect, useRef } from "react";
import Image from "next/image";
import Link from "next/link";
import { register } from "swiper/element/bundle";
import { printHTML } from "hooks/utils/formatter";
import ButtonGsfurn from "components/General/ButtonGsfurn/ButtonGsfurn";
import ArrowButton from "components/General/ButtonGsfurn/ArrowButton";

const Slider = ({ attrs }) => {
  const swiperRef = useRef(null);
  const nextRef = useRef(null);
  const prevRef = useRef(null);
  const _slides = attrs?.data?.slides;
  const slides_count = _slides?.length || 0;

  // Add extra slides for loop when there are only two images
  const slides = (slides_count < 4 && slides_count !== 1) ? _slides.concat(_slides) : _slides;

  useEffect(() => {
    if (!swiperRef.current) {
      return;
    }
    register();

    const swiperParams = {
      slidesPerView: "auto",
      spaceBetween: 24,
      centeredSlides: true,
      loop: slides_count > 1,
      navigation: {
        nextEl: nextRef?.current,
        prevEl: prevRef?.current,
      },
    };

    Object.assign(swiperRef.current, swiperParams);
    swiperRef.current.initialize();
  }, []);

  return (
    <section className={`slider_section relative mb-16 md:mb-20 ${slides_count === 1 ? "mx-auto max-w-app" : "w-screen"}`}>
      <swiper-container
        init="false"
        ref={swiperRef}
        className="px-4 xl:px-0"
      >
        {slides?.map((slide, i) => {
          return (
            <swiper-slide
              key={i}
              class={`relative w-full h-[25.5rem] lg:h-[28.75rem] ${slides_count === 1 ? "" : "mx-auto max-w-app"}`}
            >
              <Image
                src={slide?.afbeelding?.url}
                alt={slide?.afbeelding?.alt}
                className="absolute object-cover rounded-md"
                fill
              />
              <div className="absolute inset-0 w-full h-full bg-black rounded-md opacity-30" />
              <div className="absolute inset-0 flex flex-col items-center gap-4 my-auto mx-[3.5rem] h-fit lg:gap-6">
                {slide?.tekst_voor_afbeelding && (
                  <div className="max-w-xl mx-auto font-medium text-center text-white">
                    {printHTML(slide?.tekst_voor_afbeelding)}
                  </div>
                )}
                {slide?.knop_link && (
                  <ButtonGsfurn
                    pill
                    color="primary"
                    as={Link}
                    href={slide?.knop_link?.url}
                    title={slide?.knop_link?.title}
                    target={slide?.knop_link?.target}
                    needsArrow
                  >
                    {slide?.knop_link?.title || "Bekijk de collectie"}{" "}
                  </ButtonGsfurn>
                )}
              </div>
            </swiper-slide>
          )
        })}
      </swiper-container>

      {slides?.length > 1 && (
        <div className="absolute inset-0 z-20 flex items-center justify-between w-full px-6 m-auto pointer-events-none max-w-app">
          <ArrowButton
            ref={prevRef}
            back
            className="m-0 pointer-events-auto __swiper-button-prev"
          />
          <ArrowButton
            ref={nextRef}
            className="m-0 pointer-events-auto __swiper-button-next"
          />
        </div>
      )}
    </section>
  );
};

export default Slider;
